/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CompletedInputs */

const cs_enum_completed = /** @type {(inputs: Enum_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončeno`)
};

const en_enum_completed = /** @type {(inputs: Enum_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Enum_CompletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_completed = /** @type {((inputs?: Enum_CompletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CompletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_completed(inputs)
	return cs_enum_completed(inputs)
});